import { SelectOptions } from '../../Components/Selects'
import { requestGetJSON } from '../../../../NonReact/common/API/REST/RESTAPIClient'
import { USER_AGENT_URL, USER_AGENTS_URL } from '../../../../NonReact/constants/ApiConstants'
import { UserAgentDTO } from '../../Types/Types'
import { requestJSON } from '../../../../NonReact/common/API/REST/RESTClient'
import { RESTMethods } from '../../../../NonReact/constants/REST'

export const getAvailableUserAgents = (): Promise<Nullable<SelectOptions<number>>> =>
    requestGetJSON<SelectOptions<number>>(USER_AGENTS_URL)

export const getUserAgentFromSession = (): Promise<Nullable<UserAgentDTO>> =>
    requestGetJSON<UserAgentDTO>(USER_AGENT_URL)

export const setUserAgent = (userAgentID: number): Promise<Nullable<void>> =>
    requestJSON(USER_AGENT_URL, { method: RESTMethods.POST, body: { userAgentID } })
